class NewMegaMenu extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        let menuTimer

        this.activeLink = this.getAttribute("data-active-link")

        let link

        const header = this.closest("header-487")
        link = header.querySelector(
            `.mega-menu-link-${this.activeLink.split(" ").join("-")}`
        )

        link.addEventListener("mouseenter", () => {
            clearTimeout(menuTimer)
            this.mouseEnter = true
            this.classList.add("active")
            header.classList.add("show-bg")
        })

        link.addEventListener("mouseleave", () => {
            menuTimer = setTimeout(() => this.classList.remove("active"), 150)
            link.classList.remove("active")

            if (
                this.closest("header-487").getAttribute(
                    "data-page-template"
                ) === "index" &&
                !this.mouseEnter
            )
                setTimeout(() => header.classList.remove("show-bg"), 150)
        })

        this.addEventListener("mouseenter", () => {
            this.mouseEnter = true
            clearTimeout(menuTimer)
        })

        this.addEventListener("mouseleave", () => {
            this.classList.remove("active")
            link.classList.remove("active")
            this.mouseEnter = false
            if (
                this.closest("header-487").getAttribute(
                    "data-page-template"
                ) === "index"
            )
                header.classList.remove("show-bg")
        })
    }
}

customElements.define("new-megamenu", NewMegaMenu)
